import { render, staticRenderFns } from "./ListeRegeln.vue?vue&type=template&id=84ffc32e"
import script from "./ListeRegeln.vue?vue&type=script&lang=js"
export * from "./ListeRegeln.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports